if (!customElements.get('pdp-coupon-tray')) {
  customElements.define(
    'pdp-coupon-tray',
    class extends HTMLElement {
      connectedCallback() {
        this.resetTimer = null;
        this.addEventListener('click', this.handleClick.bind(this));
      }

      handleClick(event) {
        var copyBtn = event.target.closest('[data-ct-copy]');
        if (!copyBtn) return;

        var code = this.dataset.couponCode;
        if (!code) return;

        this.copyToClipboard(code);
      }

      copyToClipboard(text) {
        var self = this;

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(function () {
            self.showCopied();
          });
          return;
        }

        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          this.showCopied();
        } catch (e) {
        }
        document.body.removeChild(textarea);
      }

      showCopied() {
        var btn = this.querySelector('[data-ct-copy]');
        if (!btn) return;

        btn.classList.add('is-copied');

        if (this.resetTimer) clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(function () {
          btn.classList.remove('is-copied');
        }, 3000);
      }

      disconnectedCallback() {
        if (this.resetTimer) clearTimeout(this.resetTimer);
      }
    }
  );
}
